module.exports = __webpack_public_path__ + "static/media/wave.85f6d578.svg";